/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const nattoga: CommunityData = {
  code: "nattoga",
  inviteCode: "nattoga",
  name: "Nattöga",
  thumbnail: "https://media.werz.at/community-assets/nattoga/thumbnail.png",
  favicon: "",
  defaultCurrency: "SEK",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/nattoga`,
  socials: {
    instagramLink: "https://www.instagram.com/nattoga.sthlm/?hl=en",
  },
  styles: {
    global: {
      counterColor: "#FFFFFF",
      alternativeLogo: {
        src: "https://media.werz.at/community-assets/nattoga/logo-web.png",
        styles: "w-[129px] mb-[-20px]",
      },
      logo: {
        src: "https://media.werz.at/community/icon/cm7f9a5mg0002aq9km0bliesb?uploadTime=1744373244419&type=image&v=1762238616236",
        styles: "object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      contentBoxShadow: "border-[2px] rounded-[8px] border-[#FFF] overflow-hidden",
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "border-r-[1px] border-r-[#FFF]",
      contentBg: "#000000",
      bgDesktop: "https://media.werz.at/community-assets/nattoga/bg-web.jpg",
      bgMobile: "https://media.werz.at/community-assets/nattoga/bg-web.jpg",
      mainFont: "font-['CitrusGothic-Regular']",
      nonMemberBg: "https://media.werz.at/community-assets/nattoga/landing-web-bg.mp4?type=video",

      primaryButton:
        "flex mt-2 !text-[#000000] rounded-[8px] font-['CitrusGothic-Regular'] font-medium justify-center items-center !text-[18px] leading-[24px] !h-[48px] bg-[#FFFFFF] !px-[32px] sm:!min-w-[154px] min-w-[160px] text-nowrap cursor-pointer",
    },
    navigation: {
      sideBarSeparator: "border-r-[1px] border-[#000000]",
      iconsColor: "#FFFFFF",
      separator: "border-t-[#FFF] border-t",
      item: "text-[18px] h-[44px] text-[#FFF] flex justify-center items-center sm:!pt-2 !pt-6 sm:!pl-0 text-opacity-50",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "bg-[#000000] !pt-0 overflow-hidden",
      titles: "text-[40px] leading-[48px] font-['CitrusGothic-Regular'] text-[#FFFFFF] uppercase",
      emptyOrLoadingState: "text-[16px] !text-[#FFFFFF] ml-4 sm:ml-8",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 border-b border-[#FFF]",
        sectionTitle:
          "text-[40px] leading-[48px] font-['CitrusGothic-Regular'] text-[#FFFFFF] uppercase pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "font-['GabrieleBadAH-Regular'] text-[#FFFFFF] text-[16px] text-left leading-[120%]",
          subtitle:
            "text-[14px] font-['Mechanical-Regular'] text-[#FFFFFF] text-left leading-[16px] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 border-b border-[#FFF]",
        sectionTitle:
          "text-[40px] leading-[48px] font-['CitrusGothic-Regular'] text-[#FFFFFF] uppercase pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[160px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer:
            "w-full sm:!w-[228px] h-[183px] sm:!h-[128px] sm:flex-shrink-0 relative overflow-hidden",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent p-4",
          title:
            "font-['GabrieleBadAH-Regular'] text-[#FFFFFF] text-[16px] text-left leading-[120%] mb-2",
          subtitle:
            "text-[14px] font-['Mechanical-Regular'] text-[#FFFFFF] text-left leading-[16px]",
          location:
            "text-[14px] font-['Mechanical-Regular'] text-[#FFFFFF] text-left leading-[16px]",
          date: "text-[14px] font-['Mechanical-Regular'] text-[#FFFFFF] text-left leading-[16px]",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[24px] leading-[120%] text-[#FFFFFF] font-['GabrieleBadAH-Regular']",
        text: "text-[14px] leading-[16px] font-['Mechanical-Regular'] text-[#FFFFFF]",
        customShopImage: "https://media.werz.at/community-assets/nattoga/shop-web.png",
        customShopImageStyle: "",
        sectionTitle: "hidden",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#FFF]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4",
        title: "text-[32px] leading-[120%] font-['GabrieleBadAH-Regular'] text-[#FFFFFF] text-left",
        subtitle:
          "text-[14px] text-[#FFFFFF] font-['Mechanical-Regular'] text-left leading-[16px] mb-4 mt-2",
        button:
          "flex mt-2 !text-[#000000] rounded-[8px] font-['CitrusGothic-Regular'] font-medium justify-center items-center !text-[18px] leading-[24px] !h-[48px] bg-[#FFFFFF] !px-[32px] sm:!min-w-[154px] min-w-[160px] text-nowrap cursor-pointer mb-4 sm:mb-0",
        questions:
          "text-[12px] font-['Mechanical-Regular'] text-left leading-[130%] text-[#FFFFFF]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#FFF]",
        header:
          "text-[24px] leading-[120%] font-['GabrieleBadAH-Regular'] text-[#FFFFFF] text-left",
        text: "text-[14px] text-[#FFFFFF] font-['Mechanical-Regular'] text-left leading-[16px] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#FFF]",
        header:
          "text-[24px] leading-[120%] font-['GabrieleBadAH-Regular'] text-[#FFFFFF] text-left",
        text: "text-[14px] text-[#FFFFFF] font-['Mechanical-Regular'] text-left leading-[16px] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px] border-[2px] border-[#FFF]",
        mapPinColor: "#000000",
        mapStrokeColor: "#000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[24px] leading-[120%] font-['GabrieleBadAH-Regular'] text-[#FFFFFF] text-left",
        text: "text-[14px] text-[#FFFFFF] font-['Mechanical-Regular'] text-left leading-[16px]",
      },
      tickets: {
        header:
          "text-[40px] leading-[40px] font-['CitrusGothic-Regular'] text-[#FFFFFF] uppercase text-left px-4 sm:px-8 pt-4 sm:pt-8 pb-4 sm:pb-6 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "!bg-[#FFFFFF] border border-[#FFFFFF] rounded-[8px] px-4 py-3 text-[#000000] font-['CitrusGothic-Regular'] text-[14px] text-left !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto bg-[#ffffff00] mb-4 overflow-hidden",
          media: "!w-[64px] !h-[64px] mr-2 sm:mr-4",
          name: "text-[16px] text-[#FFFFFF] font-['GabrieleBadAH-Regular'] text-left leading-[120%]",
          description:
            "text-[14px] text-[#FFFFFF] font-['Mechanical-Regular'] text-left leading-[16px] !mt-1 normal-case line-clamp-2 flex flex-row gap-1",
          price:
            "text-[16px] text-[#FFFFFF] font-['GabrieleBadAH-Regular'] text-left leading-[120%] !mt-1",
          quantity: "text-[#000] font-['Mechanical-Regular'] text-[16px] text-left text-nowrap",
          status:
            "text-[16px] text-[#FFFFFF] font-['CitrusGothic-Regular'] uppercase text-left leading-[110%]",
          counterContainer:
            "bg-[#FFF] border-[1px] border-[#FFFFFF] rounded-[4px] !px-4 !py-3 gap-x-4 !w-fit !h-[43px]",
          button:
            "!bg-[#FFFFFF] border border-[#FFFFFF] rounded-[8px] px-4 py-3 text-[#000000] font-['CitrusGothic-Regular'] text-[14px] text-left !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default nattoga
